<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-2">
      <div class="font-weight-medium text-body-2 indigo--text text--darken-4">
        {{ title }}
      </div>
      <v-chip color="success" small class="font-weight-bold custom-chip-bg">
        {{ completionRate }}% hoàn thành
      </v-chip>
    </div>

    <!-- Progress Bar -->
    <div class="progress-bar-container d-flex w-100 mb-3">
      <div class="progress-segment bg-primary" :style="{ width: `${completionRate}%` }"></div>
      <div class="progress-segment bg-warning" :style="{ width: `${runningRate}%` }"></div>
      <div class="progress-segment bg-grey-lighten-2" :style="{ width: `${pendingRate}%` }"></div>
    </div>

    <v-row dense>
      <v-col cols="6" sm="3">
        <div class="text-body-2 grey--text">Tổng số xe</div>
        <div class="text-h6 font-weight-bold">{{ stats.total }}</div>
      </v-col>
      
      <v-col cols="6" sm="3">
        <div class="d-flex align-center mb-1">
          <div class="legend-dot bg-primary mr-2"></div>
          <span class="font-weight-bold primary--text text-subtitle-1">{{ stats.completed }}</span>
        </div>
        <div class="text-body-2 grey--text">Đã hoàn thành</div>
      </v-col>

      <v-col cols="6" sm="3">
        <div class="d-flex align-center mb-1">
          <div class="legend-dot bg-warning mr-2"></div>
          <span class="font-weight-bold warning--text text-subtitle-1">{{ stats.running }}</span>
        </div>
        <div class="text-body-2 grey--text">Chưa kết thúc</div>
      </v-col>

      <v-col cols="6" sm="3">
        <div class="d-flex align-center mb-1">
          <div class="legend-dot bg-grey mr-2"></div>
          <span class="font-weight-bold grey--text text--darken-1 text-subtitle-1">{{ stats.pending }}</span>
        </div>
        <div class="text-body-2 grey--text">Chưa khởi hành</div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'BusSessionCard',
  props: {
    title: {
      type: String,
      required: true
    },
    stats: {
      type: Object,
      default: () => ({ total: 0, completed: 0, running: 0, pending: 0 })
    }
  },
  computed: {
    completionRate() {
      if (!this.stats.total) return 0
      return Math.round((this.stats.completed / this.stats.total) * 100)
    },
    runningRate() {
      if (!this.stats.total) return 0
      return Math.round((this.stats.running / this.stats.total) * 100)
    },
    pendingRate() {
      if (!this.stats.total) return 0
      return Math.round((this.stats.pending / this.stats.total) * 100)
    }
  }
}
</script>

<style scoped>
.progress-bar-container {
  height: 8px; 
  gap: 4px;
}

.progress-segment {
  border-radius: 4px;
  transition: width 0.3s ease; 
}

.legend-dot {
  width: 16px; 
  height: 6px; 
  border-radius: 3px;
}

.bg-primary { background-color: #1976D2; }
.bg-warning { background-color: #FB8C00; }
.bg-grey-lighten-2 { background-color: #e0e0e0; }
.bg-grey { background-color: #9e9e9e; }
.custom-chip-bg { background-color: #e8f5e9 !important; color: #2e7d32 !important; }
</style>
